import { render, staticRenderFns } from "./UserAccountsDataTable.vue?vue&type=template&id=686aae20"
import script from "./UserAccountsDataTable.vue?vue&type=script&lang=js"
export * from "./UserAccountsDataTable.vue?vue&type=script&lang=js"
import style0 from "./UserAccountsDataTable.vue?vue&type=style&index=0&id=686aae20&prod&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports